<template>
  <div class="masterIndex">
		<div class="contentTop">
			<banner></banner>
			<!-- <product></product> -->
			
			<div class="contentMiddle">
				<headerview></headerview>
				
				<div class="con_all">
					<div class="con_all_one">
						<tipsign :titleName="typeVal"></tipsign>
						<span>当前位置：小小主人翁</span>
					</div>
					
					<div class="con_all_two">
						<div v-for="(item,index) in list" :key="index" class="black_signle">
							<div class="black_signle_a">
								<div>{{item.userId}}</div>
								<div style="color: #999999;">{{item.createTime}}</div>
							</div>
							<div class="black_signle_b">
								提交内容：{{item.suggestion}}
							</div>
							
							<div class="black_signle_c">
								<div class="a">{{item.auditor_dictText}}回复:</div>
								<div class="b">
									回复内容：{{item.opinion}}
								</div>
							</div>
						</div>
					</div>	
					
					<div class="con_all_three">
						<div is='footPage' class="zhini-pagination"
						  :currentPage="pageNo"
						  :totalPage="total"
						  @pageNum="pageNum"  :pagesize='pageSize'></div>
					</div>
					
				</div>	
					
			</div>	
						
		<footview></footview>

  </div>
  
 </div> 
</template>

<script>
import headerview from "../../../components/headerview/headerview.vue";
import tipsign from "../../../components/tipsign/tipsign.vue";
import footPage from '../../../components/footpage/footpage.vue'

export default {
  components: {
  	headerview,
	tipsign,
	footPage,
	
  },
  
  data() {
		return {
			typeVal:"小小主人翁",
			
			list:[],
			pageNo:1,
			total:5,
			pageSize:5,
			
		};
  },
  
  mounted() {
  	  this.getlittleMaster();
	  
  },
  
  methods: {
	  //小小主人翁
	  getlittleMaster(){
			this.$get(`web/opinionsuggest/list?pageSize=5&pageNo=${this.pageNo}`).then(res=>{
				  if(res.success){
					    this.total = res.result.total
						this.list = res.result.records
				  }
			})
	  },
	  
	  pageNum(e) {
			this.pageNo = e;
			this.getlittleMaster();
	  },
	  
	  
  }
};
</script>

<style scoped lang="scss">
	::-webkit-scrollbar {
	    width: 0px;
	}
	.masterIndex{
		.contentTop{
			// background-image: linear-gradient(#FFFFFF, #E98257);
		}
		
		.contentMiddle{
			padding-top: 1.7rem;
			height: 12.2rem;
			// border: 1px solid #FFFFFF;
			.con_all{
				height: 10rem;	
				margin: 0.1rem auto;
				// margin-left: 4rem;
				// margin-right: 4rem;
				width: 12.15rem;
				background: #FFFFFF;
				.con_all_one{
					height: 0.4rem;
					line-height: 0.4rem;
					padding-left: 0.2rem;
					border-bottom: 0.01rem solid #ededed;
					display: flex;
					justify-content: space-between;
					span{
						font-size: 0.16rem;
						margin-right: 0.2rem;
					}
				}
				.con_all_two{
					height: 8rem;
					overflow-y:auto;
					// border: 1px solid red;
					// margin-top: 0.2rem;
					.black_signle{
						padding-left: 0.2rem;
						padding-bottom: 0.2rem;
						padding-right: 0.2rem;
						// height: 3.5rem;
						// border: 1px solid red;
						border-bottom: 0.01rem solid #ededed;
						.black_signle_a{
							display: flex;
							align-items: center;
							justify-content:space-between;
							font-size: 0.18rem;
							margin-top: 0.3rem;
						}
						.black_signle_b{
							color: #999999;
							font-size: 0.18rem;
							margin-top: 0.1rem;
							line-height: 0.25rem;
						}
						.black_signle_c{
							margin-top: 0.2rem;
							height: 1.64rem;
							min-height: 1.64rem;
							background: #F3F3F3;
							border-radius: 8px;
							font-size: 0.18rem;
							.a{
								padding-top: 0.2rem;
								margin-left: 0.1rem;
							}
							.b{
								color: #999999;
								margin-top: 0.1rem;
								margin-left: 0.2rem;
							}
						}
					}
				}
					
				
			}
				
		}	
		
		
	}
	
</style>
